export default class ObjetoUbicacion{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/objeto_ubicacion',
			"new": '/api/objeto_ubicacion',
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/objetoUbicacionesService.js